import { render } from "./card-border.vue?vue&type=template&id=09c6b38f&scoped=true"
import script from "./card-border.vue?vue&type=script&lang=js"
export * from "./card-border.vue?vue&type=script&lang=js"

import "./card-border.vue?vue&type=style&index=0&id=09c6b38f&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c6b38f"]])

export default __exports__